<template>
    <transition name="fade">

        <div class="row justify-content-center">
            <loading :active.sync="processingAPI" :is-full-page="true" color="#28a745" loader="bars" />
            <div class="col-lg-10 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title bold">Share with us some information</h3>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label> Input total asset size (excluding land)</label>
                                    <div class="input-group input-group-sm">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text" style="background-color: transparent !important;">&#8369</span>
                                        </div>
                                        <!-- <input-currency v-model="formLoan.asset_size" class="form-control" :class="{'is-invalid': submitting && $v.formLoan.asset_size.$error}" /> -->
                                        <input type="number" v-model="formLoan.asset_size" class="form-control" :class="{'is-invalid': submitting && $v.formLoan.asset_size.$error}" />
                                    </div>
                                    <div>
                                        <small class="text-grey float-right bold">{{convertedAsset}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="$emit('back')"><i class="fas fa-arrow-left mr-1"></i>Back</button>
                        <button class="btn btn-primary float-right" @click="next">Next<i class="fas fa-arrow-right ml-1"></i></button>
                    </div>

                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import moment from 'moment';
    import {
        required,
        minLength,
        requiredIf,
        minValue,
        helpers
    } from 'vuelidate/lib/validators';

    const validateIf = (prop, validator) =>
        helpers.withParams({
            type: 'validatedIf',
            prop
        }, function(value, parentVm) {
            return helpers.ref(prop, this, parentVm) ? validator(value) : true
        });
    export default {
        props: ['formLoan', 'user'],

        data() {
            return {
                submitting: false,
                api: {
                    asset: false,
                    ref: false,
                    ob: false
                }
            }
        },

        validations: {
            formLoan: {
                asset_size: {
                    required,
                    minValue: minValue(1)
                },
            },
        },

        computed: {
            convertedAsset() {
                let val = this.formLoan.asset_size;
                if (val > 0) {
                    let num_parts = val.toString().split(".");
                    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    return num_parts.join(".");
                } else {
                    return '';
                }
            },
            processingAPI() {
                return Object.values(this.api).includes(true);
            },

        },
        created() {

        },
        methods: {
            next: _.debounce(function() {
                this.submitting = true;
                let asset_size = this.formLoan.asset_size;

                const form = {
                    application_id: this.formLoan.application_id,
                    asset_size: this.formLoan.asset_size,
                };

                this.$v.formLoan.$touch();

                if (this.$v.formLoan.$invalid) {} else {
                    if (asset_size > 100000000) {
                        Swal.fire({
                            icon: "info",
                            title: "Notice",
                            text: `Estimated asset size should not be greater than PhP100.0 million`,
                            allowOutsideClick: false,
                        }).then((response) => {

                        });
                    } else {
                        this.$emit('next', form);
                    }
                }
            }, 333),

            // async next() {
            //     this.submitting = true;
            //     let asset_size = this.formLoan.asset_size;

            //     const form = {
            //         application_id: this.formLoan.application_id,
            //         asset_size: this.formLoan.asset_size,
            //     };

            //     this.$v.formLoan.$touch();

            //     if (this.$v.formLoan.$invalid) {} else {
            //         if (asset_size > 100000000) {
            //             Swal.fire({
            //                 icon: "info",
            //                 title: "Notice",
            //                 text: `Estimated asset size should not be greater than PhP100.0 million`,
            //                 allowOutsideClick: false,
            //             }).then((response) => {

            //             });
            //         } else {
            //             this.submitting = false;
            //             this.$emit('next', form);
            //         }
            //     }
            // },
        },
        mounted() {}
    }
</script>



<style scoped>
    label {
        font-weight: 400 !important;
    }

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
</style>